<template>
  <div>
    <vx-card>
      <heading size="h1" style-size="h4" class="mb-5"
        >Employer Expectations and Your Rights</heading
      >

      <p class="mb-5">It is your right to:</p>

      <div class="vs-row" style="display: flex; width: 100%">
        <div class="vs-col vs-xs-12 vs-sm-8 vs-lg-9">
          <ul class="default-list">
            <li>Receive a meaningful learning experience, training or skill development.</li>
            <li>Work in a safe environment.</li>
            <li>Work unpaid for the set hours and days of your work experience placement only.</li>
          </ul>
          <p class="mb-5">The employer can reasonably expect you to:</p>
          <ul class="default-list">
            <li>Have a good attitude and show an interest.</li>
            <li>Be willing to be trained and follow instructions, especially safety rules.</li>
            <li>Be punctual, well presented, and respectful.</li>
            <li>
              Have good attendance, and if you’re sick, phone the employer and school to let them
              know straight away.
            </li>
            <li>Ask questions and communicate appropriately in the adult environment.</li>
            <li>Not use your mobile phone unless during a lunch break.</li>
          </ul>
          <h5 class="text-bold mb-5">Confidentiality</h5>
          <p class="mb-5">
            You may be exposed to information about the business and clients of the business that
            will be confidential. The very definition of confidentiality is keeping client and
            business information private.
          </p>
          <p class="mb-5">
            As an employee or work experience student, you are entrusted to treat all information
            you come across as confidential, and it is your responsibility to protect client and
            customer information.
          </p>
          <p class="mb-5">
            What you see and hear in the workplace stays at work. No matter how unimportant you
            think it is, no information can be shared with anyone outside the workplace. No
            information is to be given to customers/clients without permission from a supervisor.
          </p>
          <p class="mb-5">
            You can only access files if given permission. No confidential material or files can
            leave the business.
          </p>
          <p class="mb-5">
            No business dealings can be discussed with customers/clients outside the place of work.
          </p>
          <p class="mb-5">
            A breach of confidentiality will affect a business' reputation and can cause financial
            loss.
          </p>
          <p class="mb-5">
            You can be dismissed if confidential information is given out. Legal action may be taken
            against a person or organisation that reveals client and business information.
          </p>
          <p class="mb-5">
            In some cases, employers may want you to sign a confidentiality or non-disclosure
            agreement.
          </p>
          <p class="mb-5">
            It is essential that you understand the importance of confidentiality and are aware that
            legal implications might arise where it is not maintained.
          </p>
        </div>
        <div class="vs-col vs-xs-12 vs-sm-4 vs-lg-3 lg:pl-10 sm:pl-5">
          <img
            src="@/assets/images/workplace_preparation/new/employer_expectations.png"
            class="img-responsive"
            alt=""
          />
        </div>
      </div>

      <form id="form" class="mt-10" @submit.prevent="save">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-checkbox v-model="data.confirmed" name="confirmed"
              >I have read all the information in this module</vs-checkbox
            >
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full flex justify-between">
            <div>
              <button class="btn btn-primary btn-size-medium mr-3 mb-1">Submit</button>
              <router-link
                to="/student/workplace-preparation"
                class="btn btn-secondary btn-size-medium mb-1"
              >
                Back
              </router-link>
            </div>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
export default {
  computed: {
    data: {
      get: function () {
        return this.getModuleData();
      },
      set: function (d) {
        this.setModuleData(d);
      },
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isConfirmed() {
      return this.$store.getters['authStudent/preworkWorkplacePreparationModules'][
        this.$route.params.id
      ];
    },
    prework() {
      return this.$store.getters['authStudent/prework'];
    },
  },
  methods: {
    save() {
      this.saveModule(this.data);
    },
  },
  watch: {
    'prework.workplace_preparation_modules'() {
      const modules = this.prework.workplace_preparation_modules;
      if (modules && modules[3]) {
        this.data = modules[3];
      }
    },
  },
  mounted() {
    if (this.isConfirmed) this.data.confirmed = true;
  },
  beforeDestroy() {
    this.data.confirmed = false;
  },
  inject: ['saveModule', 'getModuleData', 'setModuleData'],
};
</script>
